import _ from 'lodash';
import IApplicationState from 'app/types/state';

function mapSelect(groupImports, n) {
  const sa = groupImports.groupImportsById[n];
  if (sa) {
    return { id: sa.id, name: sa.name };
  }
  return null;
}

export function getGroupImportsByIdInSelectFormat(groupImports): any {
  return _.map(groupImports.groupImportIds, (n) => mapSelect(groupImports, n));
}
export function getCurrentGroupImport(state: IApplicationState): any {
  if (state.groupImports.groupImportsById !== undefined && state.groupImports.currentGroupImportId !== undefined) {
    const findGroupImport = state.groupImports.groupImportsById[state.groupImports.currentGroupImportId];
    const currentGroupImport = {
      ...findGroupImport,
    };

    return currentGroupImport;
  }
  return {};
}

export function getGroupImports(state: IApplicationState): any {
  return {
    ...state.groupImports,
    currentGroupImport: {
      ...getCurrentGroupImport(state),
    },
  };
}

export function getGroupImportsByTeamId(state: IApplicationState, teamId): any {
  if (state.groupImports.groupImportsById !== undefined && teamId != null) {
    return _.filter(state.groupImports.groupImportsById, { teamId });
  }
  return {};
}

export function getGroupImportsByIds(groupImportsById, groupImportIds): any {
  if (groupImportsById !== undefined && groupImportIds != null) {
    return _.pick(groupImportsById, groupImportIds);
  }
  return {};
}

export function getGroupImportIdsByTeamId(state: IApplicationState, teamId): any {
  if (state.groupImports.groupImportsById !== undefined && teamId != null) {
    const filtered = _.filter(state.groupImports.groupImportsById, { teamId });
    if (filtered != null) {
      return _.map(filtered, 'id');
    }
    return [];
  }
  return [];
}
